import React from 'react';
import { GamesList } from '../Components';

const Games = () => {
  return (
    <div>
      <GamesList />
    </div>
  )
}

export default Games
